<template>
  <v-card tile elevation="0" :loading="loadingAcct">
    <v-card-text>
      <p class="text-h6">Choose what you need.</p>
      <div class="mt-5">
        <template v-if="config != undefined">
          <v-row>
            <v-col cols="12" md="6">
              <v-btn
                :to="'/username' + queryParams"
                depressed
                :color="config.primary_color"
                dark
                class="text-center display-1 text-capitalize"
                block
                :style="'height:' + selectHeight"
              >
                <div>
                  <div>
                    <v-icon size="60px">mdi-account-search</v-icon>
                  </div>
                  <div>User Name</div>
                </div>
              </v-btn>
            </v-col>
            <v-col cols="12" md="6">
              <v-btn
                :to="'/password' + queryParams"
                depressed
                :color="config.primary_color"
                dark
                class="text-center display-1 text-capitalize"
                block
                :style="'height:' + selectHeight"
              >
                <div>
                  <div>
                    <v-icon size="60px">mdi-form-textbox-password</v-icon>
                  </div>
                  <div>Password</div>
                </div>
              </v-btn>
            </v-col>
          </v-row>
        </template>
      </div>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  name: "retrievalChoice",
  data: function () {
    return {
      selectHeight: "150px",
      identityValid: true,
      emailAddress: "",
      loadingAcct: false,
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
    };
  },
  watch: {
    emailAddress() {
      if (this.emailAddress == "") {
        this.resetValidation();
      }
    },
  },
  methods: {
    findAccount() {
      var self = this;
      if (self.emailAddress != "") {
        this.loadingAcct = true;
        setTimeout(function () {
          self.$emit("user-found", true);
        }, 4000);
      }
    },
    validate() {
      this.$refs.indentifyForm.validate();
    },
    resetValidation() {
      this.$refs.indentifyForm.resetValidation();
    },
    resetBlurValid() {
      if (this.emailAddress == "") {
        this.$refs.indentifyForm.resetValidation();
      }
    },
  },
  computed: {
    config() {
      var self = this;
      return self.$store.getters.getConfig;
    },
    queryParams() {
      return this.$store.getters.getParams;
    },
  },
};
</script>
